export const PageHeader = ({ eyebrow, title, sub, image }) => (
  <section className="relative overflow-hidden bg-[#0D1B2A] grain">
    {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />}
    <div className="absolute inset-0 bg-gradient-to-r from-[#0D1B2A] via-[#0D1B2A]/80 to-transparent" />
    <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-20 fade-up">
      <p className="eyebrow !text-[#F4A261]">{eyebrow}</p>
      <h1 className="font-display mt-3 text-4xl font-bold text-white sm:text-5xl lg:text-6xl" data-testid="page-title">{title}</h1>
      {sub && <p className="mt-4 max-w-xl text-base text-slate-300">{sub}</p>}
    </div>
  </section>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</span>
    {children}
  </label>
);

export const inputCls =
  "h-11 w-full rounded-lg border border-[#E5E0D8] bg-white px-3 text-sm text-[#1B263B] outline-none transition-colors focus:border-[#E07A5F] focus:ring-2 focus:ring-[#E07A5F]/20";

export const PrimaryBtn = ({ className = "", ...p }) => (
  <button {...p}
    className={`inline-flex h-11 items-center justify-center gap-2 rounded-full bg-[#E07A5F] px-6 text-sm font-semibold text-white shadow-lg shadow-[#E07A5F]/30 transition-[background-color,transform] hover:bg-[#C2603F] active:scale-[.98] disabled:opacity-60 ${className}`} />
);

export const Opt = ({ v, l }) => <option value={v} label={l} />;

export const Empty = ({ children, testid }) => (
  <div className="rounded-2xl border border-dashed border-[#E5E0D8] bg-white p-12 text-center text-slate-500" data-testid={testid}>{children}</div>
);
